import { PlantProfileRoleIcon } from "./PlantProfileRoleIcon";
import { PlantProfileRoleOption } from "portal/utils/categoryCollection/category";
import { Role, roleToJSON } from "protos/robot_syncer/plant_profile";
import { Tooltip, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import React, { FC, ReactNode } from "react";
import WarningIcon from "@mui/icons-material/WarningAmberOutlined";

const PLANT_PROFILE_ROLE_SECTION_I18N_KEYS: Record<
  PlantProfileRoleOption,
  string
> = {
  [roleToJSON(Role.CROP)]:
    "components.categoryCollectionProfile.roles.crop_other",
  [roleToJSON(Role.WEED)]:
    "components.categoryCollectionProfile.roles.weed_other",
  [roleToJSON(Role.BENEFICIAL)]:
    "components.categoryCollectionProfile.roles.beneficial_other",
  [roleToJSON(Role.DISREGARD)]:
    "components.categoryCollectionProfile.roles.disregard_other",
};

interface PlantProfileRoleSectionHeaderProps {
  role: Role;
  action?: ReactNode;
}

export const PlantProfileRoleSectionHeader: FC<
  PlantProfileRoleSectionHeaderProps
> = ({ role, action }) => {
  const { t } = useTranslation();

  const titleI18nKey = PLANT_PROFILE_ROLE_SECTION_I18N_KEYS[roleToJSON(role)]!;
  return (
    <div className="flex items-center justify-between gap-2">
      <Typography variant="h6" className="flex items-center gap-2 min-w-0">
        <PlantProfileRoleIcon role={role} fontSize="large" />
        {t(titleI18nKey)}
        {role === Role.DISREGARD && (
          <Tooltip
            arrow
            title={
              <Trans
                i18nKey="components.categoryCollectionProfile.warnings.disregardRole"
                components={[<strong key={0} />]}
              />
            }
          >
            <WarningIcon color="warning" fontSize="small" tabIndex={0} />
          </Tooltip>
        )}
      </Typography>
      {action}
    </div>
  );
};
